var _Object$setPrototypeOf = require("core-js/library/fn/object/set-prototype-of.js");
function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = _Object$setPrototypeOf ? _Object$setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/helpers/setPrototypeOf.js
// module id = 411
// module chunks = 168707334958949